import { useMemo } from 'react';

import useFeatureFlags from './useFeatureFlags';

export default function useInputFontSizeClass() {
  const { uiRefreshReduceInputFontSize } = useFeatureFlags();

  return useMemo(() => (uiRefreshReduceInputFontSize ? 'text-sm' : 'text-[16px]'), [uiRefreshReduceInputFontSize]);
}
